<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main" style="padding: 60px;">
          <div class="title">
            关于我们
          </div>
          <div class="contentLeft">
            <ul class="leftNavigation">

              <li class="clickable"><a href="/about?id=xmjj"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>设施简介</a></li>

              <li class="clickable "><a href="/about8"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>研究院简介</a></li>

              <li class="clickable "><a href="/about2"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>领导团队</a></li>

              <li class="clickable active"><a href="about6?id=zhyxjd"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>科研设施</a></li>
              <li class="clickable"><a href="/about3"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>技术系统</a></li>

              <li class="clickable"><a href="/about5?id=yxgltx"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>组织架构</a></li>
            </ul>
          </div>
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
    <!--
    <v-footer></v-footer>
    <v-copy></v-copy>
    -->
  </div>
</template>
<script>
  /* eslint-disable */
  import Header from "@/components/header/";
  import Nav from "@/components/nav/";
  import Copy from "@/components/copy/"
  import Breadcrumb from "@/components/breadcrumb/"
  import Footer from "@/components/footer/"
  import Contact from "@/components/contact/";
  export default {
    data () {
      return {
        richText: '',
      };
    },
    created () {
      if(this.$route.query.id == 'zhyxjd') {
        this.richText = '<p style="text-align: left; "><span style="margin-left: 295px; font-size: 22px; border-bottom: solid 3px #0c5cc8;">基地协同</span></p>'
          + '<br/>'
          + '<p style="text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jdxt1.png" style="width: 890px; margin-right: 0px;margin-bottom: 16px;" width="800px"  border="0" vspace="0" alt=""></p>'
          + '<p style="margin-left: 295px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jsxtfb1.png" style="width: 770px; margin-right: 16px;margin-bottom: 16px;" width="800px"  border="0" vspace="0" alt=""></p>'

          + '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #0c5cc8;">闵行基地</span></p>'

          + '<div id="left" style="float:left ; width:48%; margin-left: 36px;  height:770px;">'
          + '<img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/mhjd1.png" style="margin-right: 16px;margin-bottom: 16px;margin-top: 6px;" border="0" vspace="0" alt="">'
          + '<p style="margin-bottom : 20px; margin-top: 0px;"><span style="font-size: 20px; color: white;font-weight: bold"></span></p>'
          + '<p style="margin-bottom : 20px; "><span style="font-size: 16px; ">闵行基地使用面积为 6 万平方米，同时容纳 1000 人进行科研活动， 包括流动科研人员（含研究生）900 人，平台支撑人员 100 人。</span></p>'
          + '<p style="margin-bottom : 20px; "><span style="font-size: 16px; ">综合交大本部学科优势和研究基 础，大设施闵行技术平台规划了 5 个功能子平台(临床资源深度分析 和挖掘平台、生物标记物与新药研 发平台、影像平台、诊断试剂研发 平台、仪器研发平台)和 1 个大设 施运行管理系统，可支撑 100 个课 题组同时开展研究工作。</span></p>'
          + '<ul>' +
            '<li style="margin-top: 0px; margin-left: 0px; margin-right: 26px; margin-top: 16px;font-size: 16px;">▶ 地理位置：上海市闵行区上海交通大学校内</li>' +
            '<li style="margin-top: 10px; margin-left: 0px;font-size: 16px;">▶ 建筑面积:6 万平方米</li>' +
            '<li style="margin-top: 10px; margin-left: 0px;font-size: 16px;">▶ 楼层:6 层(地上 5 层，地下 1 层 )</li>' +
            '<li style="margin-top: 10px; margin-left: 0px;font-size: 16px;">▶ 建筑高度:23.8 米</li>' +
            '</ul>'
          + '</div>'

          + '<div id="right" style="float:right ; width:46%; margin-left: 16px;  height:100%;">'
           + '<img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/四区.png" style="width: 460px; margin-right: 60px;margin-bottom: 6px;margin-top: 6px;" width="800px"  border="0" vspace="0" alt="">'
          + '<p style="margin-bottom : 20px;margin-left: 10px; "><span style="font-size: 16px; "><font color="#033d80">基本定位:</font><br/>转化医学技术研发支撑平台<br/>技术服务能力平台<br/>用户共享实验室<br/><font color="#033d80">开放对象:</font><br/>创新药物、医用材料、生物医学制造、生物医学信息、影像学、诊疗新技术等方面的科学研究与技术开发的优秀团队和科学家。</p>'
          + '</div>'

          + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
          + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'

          + '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #0c5cc8;">瑞金基地</span></p>'
          + '<div id="left" style="float:left ; width:48%; margin-left: 36px;  height:720px;">'
          + '<img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/rjjd1.png" style="margin-right:16px; margin-bottom: 16px; margin-top: 6px;" width="800px"  border="0" vspace="0" alt="">'
          + '<p style="margin-bottom : 20px; margin-top: 20px;"><span style="font-size: 20px; color: white;font-weight: bold"></span></p>'
          + '<p style="margin-bottom : 20px; margin-right: 16px; "><span style="font-size: 16px;">瑞金基地大楼建成后使用面积为 5.4 万平方米，同时容纳约 500 人 进行科研及临床试验工作。</span></p>'
          + '<p style="margin-bottom : 20px; margin-right: 16px; "><span style="font-size: 16px;">综合瑞金医院学科优势和研究基 础，大设施瑞金平台规划了 5 个功 能子平台(标准化临床生物样本库、 临床资源深度分析和挖掘平台、生 物标记物与新药研发平台、分子病 理与影像技术研究平台、转化医学 研究型病房)，其中，300 张研究 型床位全部开放可以满足同时进行 20~30 项临床研究。</span></p>'
          + '</div>'

          + '<div id="right" style="float:left ; width:45%; height:100%;">'
          + '<img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/rjjd0.png" style="margin-left: 26px; margin-bottom: 16px;" width="800px"  border="0" vspace="0" alt="">'
          + '<ul>' +
            '<li style="margin-top: 0px; margin-left: 36px; margin-right: 26px; margin-top: 26px;font-size: 16px;">▶ 地理位置：上海市黄浦区瑞金医院内</li>' +
            '<li style="margin-top: 5px; margin-left: 36px;font-size: 16px;">▶ 建筑面积: 5.4 万平方米</li>' +
            '<li style="margin-top: 5px; margin-left: 36px;font-size: 16px;">▶ 楼层: 16 层(地上 13 层，地下 3 层)</li>' +
            '<li style="margin-top: 5px; margin-left: 36px;font-size: 16px;">▶ 建筑高度: 56米</li>' +
            '</ul>'
          + '</div>'
          + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
          + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      }
    },
    components: {
      "v-header": Header,
      "v-nav": Nav,
      "v-copy": Copy,
      "v-breadcrumb": Breadcrumb,
      "v-footer": Footer,
      "v-contact": Contact,
    }
  };
</script>
<style lang="scss" scoped>
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
      @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
  }

  .b-richtext {
    text-align:left;
    margin-top: -50px;
    b,
    strong {
      font-weight: 700;
    }
    p {
      margin: 0 0 20px;
    }
    line-height: 32px;
  }

  ///////////////
  .title {
    width: 230px;
    margin-bottom: 0px;
    position: relative;
    padding: 10px 15px 11px;
    background: #0c5cc8;
    font-size: 22px;
    font-weight: 500;
    color:#ffffff;
    text-transform:uppercase;
  }
  .contentLeft {
    width: 230px;
    float: left;
    margin-right: 35px;
    top: 0;
    left: 0;
    background-color: #f2f7ff;
  }

  .contentRight {
    padding: 1.3rem 2rem;
    margin-left: 250px;
  }

  .leftNavigation {
    margin: 0rem 0;
  }
  .leftNavigation li {border-bottom: solid 1px #c6dbf5;border-right: solid 1px #c6dbf5;}
  .leftNavigation, .leftNavigation li ul {
    list-style: none;
    padding: 0;
  }
  .leftNavigation li a {
    font-size: 16px;
    display: block;
    padding: 10px 30px 10px 20px;
    color: #1f1f1f;
    /*border-bottom: solid 1px #1e76b8;*/
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    -webkit-transition: color 0.2s ease;
    transition: color 0.2s ease;
    font-weight:400;border-left: #c6dbf5 solid 5px;
    border-right: #c6dbf5 solid 5px;
  }
  .leftNavigation li a, .leftNavigation li a .leftNavIcon {
    line-height: 160%;
  }
  .leftNavigation li a .leftNavIcon {
    position: absolute;
    top: 0;
    left: -1px;
    /*width: 3rem;*/
    padding: 6px 0;
    text-align: center;
    font-weight:100;color: #f2f7ff;font-size: 20px;
  }
  .leftNavigation li.active a .leftNavIcon {color: #7396c3;}
  .leftNavigation li a .leftNavIcon1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 4rem;
    padding: 0.8rem 0;
    text-align: center;
  }
  .leftNavigation li a:hover {
    color: #142e8f; text-decoration:none; background:#d6e7fd;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li a:hover .leftNavIcon {color: #7396c3;}
  .leftNavigation li ul {
    /*display: none;*/
    margin: 0;border-top: solid 1px #c6dbf5;border-left: #c6dbf5 solid 5px;padding: 8px 0;
  }
  .leftNavigation li ul li { border-bottom: solid 0px #1e76b8;}
  .leftNavigation li ul li a {
    border: 0px; font-size:13px; color:#383838; background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;padding: 5px 15px 5px 48px;border-left: 0;
  }
  .leftNavigation li ul li a:hover {
    background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;color:#142e8f;text-decoration:none;border: 0;
  }
  /*#

   li ul li:last-child a {
    border-bottom: none;
  }*/
  .leftNavigation li ul li.active a {
    color: #8bebff; text-decoration:none;
  }
  .leftNavigation li.active > a {
    color: #142e8f; text-decoration:none;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li.active ul {
    display: block;border-top: solid 1px #1e76b8;
  }
  .leftNavigation > li.active {
    background-color: #d6e7fd;
  }
  .leftNavigation li ul li .level4 {border-top: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li a {
    border-bottom: solid 0px #D0E9F3; font-size:14px; color:#e2f5fa; padding-left:42px;background: transparent;border-left: #2473c0 solid 5px;
  }
  .leftNavigation li ul li .level4 li a:hover {color: #8bebff;}
  .leftNavigation li ul li .level4 li {border-bottom: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li:last-child {border-bottom: solid 0px #D0E9F3;}
</style>



// WEBPACK FOOTER //
// src/pages/about6/index.vue